<template>
  <div class="footer">
    <div class="div flex">
      <div class="div_left">
        <div class="fs20">企业公众号</div>
        <div class="mt20 mb20">
          <img
            class="div_left_img"
            :src="require('@/assets/image/page_image/home/ewm.svg')"
            alt=""
          />
        </div>
        <div class="color9E9FA1 fs16">扫一扫进入官方微信</div>
      </div>
      <div class="div_right flex">
        <div class="view">
          <div class="fs20">联系我们</div>
          <div class="flex_a box1 mt20">
            <div class="flex_a flexn">
              <img
                class="img mr5 flexn"
                :src="require('@/assets/image/page_image/home/lxdh.svg')"
                alt=""
              />
              <div class="color9E9FA1 flexn">联系电话：</div>
            </div>
            <div>189-3245-1850</div>
          </div>
          <div class="flex_a box1 mt26">
            <div class="flex_a flexn">
              <img
                class="img mr5 flexn"
                :src="require('@/assets/image/page_image/home/kfdh.svg')"
                alt=""
              />
              <div class="color9E9FA1 flexn">客服电话：</div>
            </div>
            <div>0731-88319771</div>
          </div>
          <div class="flex_a box1 mt26">
            <div class="flex_a flexn">
              <img
                class="img mr5 flexn"
                :src="require('@/assets/image/page_image/home/qqhm.svg')"
                alt=""
              />
              <div class="color9E9FA1 flexn">Q Q号码：</div>
            </div>
            <div>3102097791</div>
          </div>
          <div class="flex_a box1 mt26">
            <div class="flex_a flexn">
              <img
                class="img mr5 flexn"
                :src="require('@/assets/image/page_image/home/qyyx.svg')"
                alt=""
              />
              <div class="color9E9FA1 flexn">企业邮箱：</div>
            </div>
            <div>wonsun@wonsun.com.cn</div>
          </div>
          <div class="flex_a box1 mt26">
            <div class="flex_a flexn">
              <img
                class="img mr5 flexn"
                :src="require('@/assets/image/page_image/home/gsdz.svg')"
                alt=""
              />
              <div class="color9E9FA1 flexn">公司地址：</div>
            </div>
            <div>湖南省长沙市岳麓区麓山南路966号中国五矿麓山科创园G4栋</div>
          </div>
        </div>

        <div class="view2">
          <div class="div_right_box flex_a">
            <div class="box2">参考链接</div>
            <div class="box3"></div>
          </div>
          <div class="div_right_box flex_a mt20">
            <div class="box2 color9E9FA1">
              <a href="https://zfjr.wonsun.com.cn/" target="_blank">
                住房金融生态平台
              </a>
            </div>
            <div class="box3 color9E9FA1">
              <a href="https://yljr.wonsun.com.cn/" target="_blank">
                养老金融生态平台
              </a>
            </div>
          </div>
          <div class="div_right_box flex_a mt20">
            <div class="box2 color9E9FA1">
              <a href="https://yszjjg.wonsun.com.cn" target="_blank">
                商品房预售资金监管平台
              </a>
            </div>
            <div class="box3 color9E9FA1">
              <a href="https://wxzj.wonsun.com.cn" target="_blank">
                住宅专项维修资金管理
              </a>
            </div>
          </div>
          <div class="div_right_box flex_a mt20">
            <div class="box2 color9E9FA1">
              <a href="https://esfzjjg.wonsun.com.cn" target="_blank">
                存量房交易资金监管系统
              </a>
            </div>
            <div class="box3 color9E9FA1">
              <a href="http://zfbz.wonsun.com.cn" target="_blank">
                保障性住房管理系统
              </a>
            </div>
          </div>
          <div class="div_right_box flex_a mt20">
            <div class="box2 color9E9FA1">
              <a href="https://zhgz.wonsun.com.cn" target="_blank">
                智慧国资平台
              </a>
            </div>
            <div class="box3 color9E9FA1">
              <a href="http://jzxj.wonsun.com.cn" target="_blank">
                奖助学金管理系统
              </a>
            </div>
          </div>

          <div class="div_right_box flex_a mt20">
            <div class="box2 color9E9FA1">
              <a href="https://xyh.wonsun.com.cn/" target="_blank">
                互联网+校友会平台
              </a>
            </div>
            <div class="box3 color9E9FA1"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="line mb20"></div>

    <div class="div2 flex">
      <div class="left">
        <div class="color9E9FA1">
          湖南华信软件股份有限公司 Copyright© 2018-2020
        </div>
        <div class="color9E9FA1 mt12">
          湘公网安备 43011102000557号 湘ICP备11000624号
        </div>
      </div>
      <div class="right">
        <div class="color9E9FA1">金融 | 政务 | 教育</div>
        <div class="color9E9FA1 mt12">网站地图 站长统计</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang='scss' scoped>
.color9E9FA1 {
  color: #9e9fa1;
}

.flexn {
  flex: none;
}

.footer {
  padding-bottom: 26px;
  color: #fff;
  height: 100%;
  background: #252d37;

  .div {
    padding: 60px 240px 26px 240px;
    font-size: 18px;

    .div_left {
      flex: none;
      margin-right: 130px;

      .div_left_img {
        width: 171px;
        height: 171px;
      }
    }

    .div_right {
      flex: 1;

      .view {
        width: 45%;

        .box1 {
          align-items: baseline;
        }

        .img {
          width: 16px;
          height: 16px;
        }
      }

      .view2 {
        flex: 1;

        .div_right_box {
          // .box1 {
          //   width: 55%;
          // }

          .box2 {
            width: 50%;
            margin: 0 80px 0 50px;
            a {
              text-decoration: none;
              color: #9e9fa1;
            }
          }

          .box3 {
            width: 50%;
            a {
              text-decoration: none;
              color: #9e9fa1;
            }
          }
        }
      }
    }
  }

  .line {
    width: 100%;
    height: 1px;
    background: #4b4e53;
  }

  .div2 {
    font-size: 16px;
    justify-content: space-between;
    padding: 0 240px;
  }
}
</style>